import { getClassesByUser } from '../../services/data-entry/assessments.service';

export const UPDATE_ASSESSMENTS_BUILDER_LIST = 'UPDATE_ASSESSMENTS_BUILDER_LIST';
export const TOGGLE_ASSESSMENTS_BUILDER_LIST_LOADING = 'TOGGLE_ASSESSMENTS_BUILDER_LIST_LOADING';
export const ASSESSMENTS_BUILDER_LIST_ERROR = 'ASSESSMENTS_BUILDER_LIST_ERROR';
export const UPDATE_ASSESSMENTS_BUILDER_STUDENTS_LIST = 'UPDATE_ASSESSMENTS_BUILDER_STUDENTS_LIST';
export const UPDATE_ASSESSMENTS_BUILDER_FILTERED_STUDENTS = 'UPDATE_ASSESSMENTS_BUILDER_FILTERED_STUDENTS';
export const UPDATE_ASSESSMENTS_BUILDER_TEMPLATE = 'UPDATE_ASSESSMENTS_BUILDER_TEMPLATE';
export const UPDATE_ASSESSMENTS_BUILDER_CLASS = 'UPDATE_ASSESSMENTS_BUILDER_CLASS';
export const UPDATE_ASSESSMENTS_BUILDER_REVIEWERS = 'UPDATE_ASSESSMENTS_BUILDER_REVIEWERS';
export const USERS_CHECKED_STUDENTS_IDS = 'USERS_CHECKED_STUDENTS_IDS';
export const UPDATE_ASSESSMENT = 'UPDATE_ASSESSMENT';
export const RESET_ASSESSMENT_BUILDER_STATE = 'RESET_ASSESSMENT_BUILDER_STATE';

export const updateAssessmentsBuilderStudentsList = (value = []) => ({
  type: UPDATE_ASSESSMENTS_BUILDER_STUDENTS_LIST,
  payload: { name: 'studentsList', value }
});

export const updateAssessmentsBuilderFilteredStudents = (value = []) => ({
  type: UPDATE_ASSESSMENTS_BUILDER_FILTERED_STUDENTS,
  payload: { name: 'filteredStudents', value }
});
export const updateAssessmentsBuilderTemplate = (value = []) => ({
  type: UPDATE_ASSESSMENTS_BUILDER_TEMPLATE,
  payload: { name: 'template', value }
});

export const updateAssessmentsBuilderClass = (value = {}) => ({
  type: UPDATE_ASSESSMENTS_BUILDER_CLASS,
  payload: { name: 'class', value }
});
export const updateAssessmentsBuilderReviewers = (value = []) => ({
  type: UPDATE_ASSESSMENTS_BUILDER_REVIEWERS,
  payload: { name: 'reviewers', value }
});

export const updateAssessmentsBuilderList = (value = []) => ({
  type: UPDATE_ASSESSMENTS_BUILDER_LIST,
  payload: { name: 'list', value }
});

export const assessmentsBuilderListError = (value = null) => ({
  type: ASSESSMENTS_BUILDER_LIST_ERROR,
  payload: { name: 'error', value }
});

export const toggleLoadingAssessmentsBuilder = (value = false) => ({
  type: TOGGLE_ASSESSMENTS_BUILDER_LIST_LOADING,
  payload: { name: 'loading', value }
});

export const checkedStudentsIds = (ids = []) => ({
  type: USERS_CHECKED_STUDENTS_IDS,
  ids
});

export const updateAssessmentBuilder = (payload = {}) => ({
  type: UPDATE_ASSESSMENT,
  payload: { ...payload }
});

export const resetAssesmentBuilder = (payload = {}) => ({
  type: RESET_ASSESSMENT_BUILDER_STATE,
  payload: {}
});

const getStudentsFromClasses = (classes = []) => {
  const uniqueStudentsMap = new Map(); // Create an empty map

  classes.forEach((klass) => {
    const { students, yearlevel, code, name } = klass;
    const newStudents = students?.map((student) => {
      return { ...student, yearlevel, class: { code, name } };
    });

    newStudents.forEach((student) => {
      if (!uniqueStudentsMap.has(student._id)) {
        uniqueStudentsMap.set(student._id, student);
      }
    });
  });

  return Array.from(uniqueStudentsMap.values()); // Extract values from map
};

export const loadClassesByTeacher = () => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingAssessmentsBuilder(true));
      dispatch(assessmentsBuilderListError({}));

      const { data } = await getClassesByUser();

      if (data) {
        const studentsList = getStudentsFromClasses(data);

        dispatch(updateAssessmentsBuilderStudentsList(studentsList ?? []));
        dispatch(updateAssessmentsBuilderList(data ?? []));
        return;
      } else {
        dispatch(updateAssessmentsBuilderStudentsList([]));
        dispatch(updateAssessmentsBuilderList([]));
      }
    } catch (error) {
      dispatch(updateAssessmentsBuilderStudentsList([]));
      dispatch(updateAssessmentsBuilderList([]));
    } finally {
      dispatch(assessmentsBuilderListError({}));
      dispatch(toggleLoadingAssessmentsBuilder(false));
    }
  };
};

export const ASSESSMENTS_BUILDER_UPDATE_LIST_STUDENTS = 'ASSESSMENTS_BUILDER_UPDATE_LIST_STUDENTS';
export const ASSESSMENTS_BUILDER_UPDATE_LIST_STUDENTS_ERROR =
  'ASSESSMENTS_BUILDER_UPDATE_LIST_STUDENTS_ERROR';
export const ASSESSMENTS_BUILDER_TOGGLE_LOADING_STUDENTS = 'ASSESSMENTS_BUILDER_TOGGLE_LOADING_STUDENTS';

export const updateAssessmentsBuilderListStudents = ({ data = [], count = 0 }) => ({
  type: ASSESSMENTS_BUILDER_UPDATE_LIST_STUDENTS,
  payload: { data, count }
});
export const assessmentsBuilderListStudentsError = (error = null) => ({
  type: ASSESSMENTS_BUILDER_UPDATE_LIST_STUDENTS_ERROR,
  payload: { error }
});
export const toggleLoadingAssessmentsBuilderListStudents = (loading = false) => ({
  type: ASSESSMENTS_BUILDER_TOGGLE_LOADING_STUDENTS,
  payload: { loading }
});

export const ASSESSMENTS_BUILDER_UPDATE_LIST_CLASSES = 'ASSESSMENTS_BUILDER_UPDATE_LIST_CLASSES';
export const ASSESSMENTS_BUILDER_UPDATE_LIST_CLASSES_ERROR = 'ASSESSMENTS_BUILDER_UPDATE_LIST_CLASSES_ERROR';
export const ASSESSMENTS_BUILDER_TOGGLE_LOADING_CLASSES = 'ASSESSMENTS_BUILDER_TOGGLE_LOADING_CLASSES';

export const updateAssessmentsBuilderListClasses = ({ data = [], count = 0 }) => ({
  type: ASSESSMENTS_BUILDER_UPDATE_LIST_CLASSES,
  payload: { data, count }
});
export const assessmentsBuilderListClassesError = (error = null) => ({
  type: ASSESSMENTS_BUILDER_UPDATE_LIST_CLASSES_ERROR,
  payload: { error }
});
export const toggleLoadingAssessmentsBuilderListClasses = (loading = false) => ({
  type: ASSESSMENTS_BUILDER_TOGGLE_LOADING_CLASSES,
  payload: { loading }
});
